<script lang="ts" setup>
import { Location } from '@/models/location.model';
import { ShiftCMSState } from '@/store';
import { LocationsActions, LocationsState } from '@/stores/locations.store';
import { ref, computed, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  label: {
    type: String,
  },
  modelValue: {
    type: Object as PropType<Location | undefined>,
    required: true,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
});

const store = useStore<ShiftCMSState & { los: LocationsState }>();
const emit = defineEmits(['update:modelValue', 'change']);

const location = ref<Location | undefined>(props.modelValue);

const locationItems = computed(() =>
  [...store.state.los.items]
    .sort((a, b) => (a.name > b.name ? -1 : 1))
    .map((c) => {
      return {
        title: `${c.name}`,
        value: c,
      };
    }),
);

function update(v: Location) {
  emit('update:modelValue', v);
  emit('change');
}

watch(
  () => props.modelValue,
  () => {
    location.value = props.modelValue;
  },
  { deep: true },
);

onMounted(() => {
  store.dispatch(LocationsActions.GetLocations);
});
</script>
<template>
  <v-autocomplete
    :label="props.label ? props.label : 'Location'"
    v-model="location"
    :items="locationItems"
    chips
    :disabled="disabled"
    :multiple="false"
    :valueComparator="(a, b) => a.id === b.id"
    @update:modelValue="update"
    ><template v-slot:item="{ props }">
      <v-list-item v-bind="props">
        <v-list-item-title></v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
  <v-container style="padding-top: 0; padding-bottom: 0">
    <v-alert type="warning" density="compact" v-if="!location && required"
      >This is required</v-alert
    >
  </v-container>
</template>
